(() => {
  const KEY = 'lic-compare';
  const MAX = 3;
  const bar = document.querySelector('[data-lic-compare-bar]');
  const list = document.querySelector('[data-lic-compare-list]');
  if (!bar || !list) return;

  const labels = {
    product: bar.getAttribute('data-label-product') || '',
    spec: bar.getAttribute('data-label-spec') || '',
    price: bar.getAttribute('data-label-price') || '',
    open: bar.getAttribute('data-label-open') || '',
  };

  const escapeHtml = (value) =>
    String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;');

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  };

  const write = (items) => localStorage.setItem(KEY, JSON.stringify(items));

  const render = () => {
    const items = read();
    if (!items.length) {
      list.innerHTML = '';
      bar.hidden = true;
      document.body.classList.remove('lic-compare-open');
      document.querySelectorAll('[data-lic-card]').forEach((card) => {
        const box = card.querySelector('[data-lic-compare]');
        if (box) box.checked = false;
      });
      return;
    }

    const cell = (item, inner) =>
      `<td><a href="${escapeHtml(item.url)}">${inner}</a></td>`;

    list.innerHTML = `
      <table class='lic-compare-table'>
        <thead>
          <tr>
            <th></th>
            ${items.map((item) => `<th>${escapeHtml(item.title)}</th>`).join('')}
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>${escapeHtml(labels.spec)}</th>
            ${items.map((item) => `<td>${escapeHtml(item.spec)}</td>`).join('')}
          </tr>
          <tr>
            <th>${escapeHtml(labels.price)}</th>
            ${items.map((item) => `<td>${escapeHtml(item.price)}</td>`).join('')}
          </tr>
          <tr>
            <th></th>
            ${items.map((item) => cell(item, escapeHtml(labels.open))).join('')}
          </tr>
        </tbody>
      </table>
    `;
    bar.hidden = false;
    document.body.classList.add('lic-compare-open');
    document.querySelectorAll('[data-lic-card]').forEach((card) => {
      const box = card.querySelector('[data-lic-compare]');
      if (box) box.checked = items.some((item) => String(item.id) === String(card.dataset.id));
    });
  };

  const shake = (el) => {
    if (!el) return;
    el.classList.remove('is-shake');
    void el.offsetWidth;
    el.classList.add('is-shake');
  };

  document.addEventListener('change', (event) => {
    const box = event.target.closest('[data-lic-compare]');
    if (!box) return;
    const card = box.closest('[data-lic-card]');
    if (!card) return;
    let items = read();
    const id = card.dataset.id;
    if (box.checked) {
      if (items.some((item) => String(item.id) === String(id))) return;
      if (items.length >= MAX) {
        box.checked = false;
        shake(bar);
        return;
      }
      items.push({
        id,
        title: card.dataset.title,
        spec: card.dataset.spec,
        price: card.dataset.price,
        url: card.dataset.url,
      });
    } else {
      items = items.filter((item) => String(item.id) !== String(id));
    }
    write(items);
    render();
  });

  bar.addEventListener('click', (event) => {
    if (!event.target.closest('[data-lic-compare-clear]')) return;
    write([]);
    render();
  });

  render();
})();
